/**
 * 报错信息类：将报错信息包装成一个类，从而外部也能调用。
 */
class HttpException {
    code = '99'
    message = ''
    success = false

    constructor(code, message) {
        this.code = code
        this.message = message
    }
}

export {
    HttpException
}


// WEBPACK FOOTER //
// ./src/lib/exception/http-exception.js